export enum QueryTemplateAuditAction {
  Create = 'create',
  Update = 'update',
  Promote = 'promote',
  Delete = 'delete',
}

// Value of auditlogs.tablename for query template entries
export const QUERY_TEMPLATE_AUDIT_TABLE = 'query_template';
